import React, { memo, useCallback } from 'react';
import Map from '@/components/Map';
import Image from '@/shared/Image';
import { parseMediaFromCMS } from '@/utils/image';
import useScreen from '@/hooks/useScreen';

type APlusContentProps = {
  mobileImages: any;
  desktopImages: any;
  title?: string;
};

const APlusContent = (props: APlusContentProps) => {
  const { mobileImages, desktopImages } = props;
  const { isDesktop } = useScreen();
  const render = useCallback((image: any, index: number) => {
    const { src, alt, height, width } = parseMediaFromCMS({ data: image });
    return (
      <Image
        key={index}
        alt={alt}
        src={src}
        className="h-auto w-full"
        width={width}
        height={height}
        loading="lazy"
      />
    );
  }, []);

  return <Map list={isDesktop ? desktopImages?.data : mobileImages?.data} render={render} />;
};

export default memo(APlusContent);
